<template>
    <div class="main">
        <div class="main-top">
            <img v-if="bannerImg" :src="bannerImg" alt="">
        </div>
        <div class="white-bg">
            <div class="contentWidth">
                <div class="main-title flexColumn">
                    <p>关于我们</p>
                    <img src="../../assets/images/abouts/ABOUT US.png" alt="" style="width: 167px;margin-top: -14px;">
                    <div class="main-title-border"></div>
                </div>
                <div class="main-contents flex">
                  <img class="main-contents-abouts" :src="aboutData.ntqBriefIntroductionImage" alt="">
                  <div class="main-contents-text" v-html="aboutData.ntqBriefIntroduction">
                  </div>
                </div>
            </div>
        </div>
        <div class="gray-bg">
            <div class="contentWidth">
              <div class="main-title flexColumn">
                  <p>内推数据</p>
                  <img src="../../assets/images/abouts/INTERNAL.png" alt="" style="width: 364px;margin-top: -14px;">
                  <div class="main-title-border"></div>
              </div>
              <div class="main-contents flexBetween">
                <div class="main-contents-datas flexColumn">
                  <img src="../../assets/images/abouts/about1.png" alt="" srcset="">
                  <p class="num">{{ntqData.companyCount}}</p>
                  <p >合作公司</p>
                </div>

                <div class="main-contents-datas flexColumn">
                  <img src="../../assets//images/abouts/about6.png" alt="" srcset="">
                  <p class="num">{{ntqData.recruitingCompanyCount}}</p>
                  <p >在招公司数</p>
                </div>


                <div class="main-contents-datas flexColumn">
                  <img src="../../assets/images/abouts/about2.png" alt="" srcset="">
                  <p class="num">{{ntqData.positionCount}}</p>
                  <p >发布职位</p>
                </div>

                <div class="main-contents-datas flexColumn">
                  <img src="../../assets/images/abouts/about3.png" alt="" srcset="">
                  <p class="num">{{ntqData.deliveryCount}}</p>
                  <p >内推人数</p>
                </div>

                <div class="main-contents-datas flexColumn">
                  <img src="../../assets/images/abouts/about4.png" alt="" srcset="">
                  <p class="num">{{ntqData.positionTotalCount}}</p>
                  <p >在招职位</p>
                </div>

                <div class="main-contents-datas flexColumn">
                  <img src="../../assets/images/abouts/about5.png" alt="" srcset="">
                  <p class="num">{{ntqData.fans}}</p>
                  <p >公众号粉丝</p>
                </div>




              </div>

            </div>
        </div>
        <!-- 过往活动 -->
        <!-- <div class="white-bg">
            <div class="contentWidth">
              <div class="main-title flexColumn">
                  <p>过往活动</p>
                  <img src="../../assets/images/abouts/ACTIVIT.jpg" alt="" style="width: 284px;margin-top: -14px;">
                  <div class="main-title-border"></div>
              </div>
              <div class="main-contents flexBetween">
                <div class="boxShadow main-contents-activity">
                  <img src="../../assets/images/abouts/activity1.png" alt="" class="main-contents-activityimg">
                  <p class="textOver">过往活动的名称或主题还是接电话都分开了多久</p>
                </div>

                <div class="boxShadow main-contents-activity">
                  <img src="../../assets/images/abouts/activity2.png" alt="" class="main-contents-activityimg">
                  <p class="textOver">过往活动的名称或主题还是接电话都分开了多久</p>
                </div>
                <div class="boxShadow main-contents-activity">
                  <img src="../../assets/images/abouts/activity3.png" alt="" class="main-contents-activityimg">
                  <p class="textOver">过往活动的名称或主题还是接电话都分开了多久</p>
                </div><div class="boxShadow main-contents-activity">
                  <img src="../../assets/images/abouts/activity4.png" alt="" class="main-contents-activityimg">
                  <p class="textOver">过往活动的名称或主题还是接电话都分开了多久</p>
                </div>

              </div>

            </div>
        </div> -->
        <div class="white-bg">
            <div class="contentWidth">
              <div class="main-title flexColumn">
                  <p>我们的服务</p>
                  <img src="../../assets/images/abouts/SERVICE.png" alt="" style="width: 231px;margin-top: -14px;">
                  <div class="main-title-border"></div>
              </div>
              <div class="main-contents flexBetween ">
                <div class="">
                  <div class="main-contents-serve flex">
                    <div class="boxShadow imgBox" v-for="item in serveData" :key="item.id">
                       <img :src="item.serviceImageConfig" alt="">
                       <div>{{item.serviceName}}</div>
                    </div>
                  </div>
                  <div class="flex main-serves">
                    <div class="main-contents-tel">联系人及电话：李先生/15279054611</div>
                    <el-popover
                      placement="right-end"
                      title=""
                      width="300"
                      trigger="hover"
                      >
                      <div class="main-serves-weichat">
                        <p class="main-serves-weichat-title">联系方式</p>
                        <div >
                          <img src="../../assets/images/abouts/serveWeichat.jpg" alt="" style="width: 200px;">
                        </div>
                        <p>扫码加微信</p>
                        <p>沟通更方便</p>
                      </div>
                      <el-button style="padding: 0;" type="primary" slot="reference">
                        <div> <!-- 微信 -->
                        <img src="../../assets/images/abouts/weixin.jpg" alt="" style="width:56px;height: 40px;">
                      </div>
                       
                      </el-button>
                    </el-popover>
                  </div>
                </div>
                <img src="../../assets/images/abouts/serveMan.png" alt="" style="width:484px;">

              </div>
            </div>
        </div>
        <div class="gray-bg">
            <div class="contentWidth">
              <div class="main-title flexColumn">
                  <p>合作企业</p>
                  <img src="../../assets/images/abouts/COOPERATIVE.png" alt="" style="width: 227px;margin-top: -14px;">
                  <div class="main-title-border"></div>
              </div>
              <div class="main-contents flexWarp flex">
                <div v-for="(item) in cooperate" :key="item.id" class="boxShadow main-contents-coper">
                    <img :src="item.cooperativeEnterpriseImageUrl" alt="" />
                </div>
              </div>
            </div>
        </div>
    </div>
</template>
  
  <script>

import { mapActions, mapState,mapGetters } from "vuex";
  export default {
    components: {
    
    },
    name: "about",
    data() {
      return {
        bannerImg:null
      };
    },
    computed: {
      ...mapState({
        ntqData: state => state.about.ntqData,//蓉e聘-C端数据
        serveData:state => state.about.serveData, //我们的服务
        cooperate:state => state.about.cooperate, //合作企业
        aboutData:state => state.about.aboutData, //关于我们
      }),
     
    },
    async created() {

      await this.getServeData({type:1});
      await this.getNtqData(); //蓉e聘-C端数据
      await this.getCopeData();//合作企业
      await this.getBanner();
      await this.getAboutData();
      
      
      
    },
    methods: {
      ...mapActions([
        "getNtqData",
        "getServeData",
        "getCopeData",
        "getHomeImg",
        "getAboutData"
        
      ]),
  
     
      // 获得筛选工作列表
      async getJobsList() {
        this.loading = true;
        await this.getJobs({
          ...this.conditions,
          name: this.queryName,
          pageIndex: this.pageIndex,
          pageSize: this.pageSize
        });
        this.loading = false;
      },
      async getBanner(){
        let datas ={
          publishPlatformType:1,
          webShowPosition:3
        }
        let res = await this.getHomeImg({
          ...datas
        });
        if(res){
          this.bannerImg = res[0].image_url;
        }
        
      },

     
    
   
   
    },
  
  };
  </script>
  <style lang="less" scoped>
  .main-top{
    line-height: 0;
    img{
      width: 100%;
    }
    // height:400px ;
    // background: url('../../assets/images/abouts/about.png' ) 100% 100%;
    // background-size: 100% 100%;
    &-bg{
        background-color: rgba(9,39,104,0.3);
        width: 100%;
        height: 100%;
    }
   

    
  }
 .main{
    .white-bg{
        background-color: #fff;
    }
    .gray-bg{
        background: #F6F9FD;
    }
    &-title{
        text-align: center;
        margin: 0 auto;
        font-size: 32px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #082400;
        p{
            font-size: 32px;
            font-family: PingFangSC-Semibold, PingFang SC;
            font-weight: 600;
            color: #082400;
            line-height: 45px;
            // background: linear-gradient(180deg, #FFFFFF 0%, #899CFF 100%);
            // background-clip: text;
            // -webkit-background-clip: text;
            // -webkit-text-fill-color: transparent;
        }
        &-border{
          width: 46px;
          height: 8px;
          background: #2450CE;
          border-radius: 4px;
          margin: 20px 0 30px;
        }
    }
    &-contents{
      &-abouts{
        width: 434px;
        margin-right: 30px;
      }
      &-text{
        height: 222px;
        width: 806px;
        overflow: auto;
        font-size: 16px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #082400;
        line-height: 28px;
      }
      &-datas{
        img{
          width: 112px;
          height: 112px;
        }
      
        p{
            font-size: 24px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: rgba(0,0,0,0.65) !important;
            line-height: 33px;
        }
        .num{
          font-size: 48px;
          font-family: DIN-BlackItalic, DIN;
          padding: 0 4px;
          font-weight: bold;
          color: #082400;
          font-style: oblique;
          line-height: 59px;
          background: linear-gradient(180deg, #69BEFF 0%, #3789FF 100%);
          background-clip: text;
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
        }
      }
      .boxShadow{
        background: #fff;
      }
      &-activity{
        width: 302px;
        img{
          width: 100%;
          height: 170px;
          border-radius: 6px 6px 0px 0px;
          background-color: #F6F9FD;
        }
        p{
          padding: 10px 20px 20px ;
        }
        font-size: 18px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #082400;
      }
      &-serve{
        width: 784px;
        flex-wrap: wrap;
        .imgBox{
          position: relative;
          padding: 8px 20px;
          width: 360px;
          height: 148px;
          margin-bottom: 10px;
          &:not(:nth-child(2n)){
            margin-right: 10px;
          }
          img{
            width: 100%;
            
          }
          div{
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%,-50%);
            font-size: 18px;
            font-family: PingFangSC-Semibold, PingFang SC;
            font-weight: 600;
            color: #FFFFFF;
            line-height: 25px;
            text-shadow: 0px 2px 4px rgba(0,0,0,0.5);
          }
        }
        
      }
      &-tel{
        width: 274px;
        margin-left: 14px;
        margin-right: 20px;
        height: 40px;
        line-height: 40px;
        text-align: center;
        // padding: 10px 20px;
        background: #287CF3;
        box-shadow: 0px 8px 24px -6px rgba(40,124,243,0.2);
        border-radius: 6px;
        border: 1px solid #287CF3;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #FFFFFF;
      }
      .main-serves{
        .el-button--primary{
          background: none;
          border:none;
          border-color:none;
        }
      }
      &-coper{
        // padding: 10px;
        width: 202px;
        height: 106px;
        margin-bottom: 10px;
        img{
          width: 202px;
        }
        &:not(:nth-child(6n)){
          margin-right: 10px;
        }
      }

    }
   
    .contentWidth{
        padding:70px 0 ;
        
    }

 }
 .main-serves-weichat{
  div{
    padding: 10px;
  }

   img{
    width: 100%;
   }
    p{
      text-align: center;
      font-size: 16px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #082400;
      line-height: 32px;
    }
      &-title{
        font-size: 18px;
        text-align: left !important;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: rgba(0,0,0,0.85);
        line-height: 24px;
        padding-bottom: 10px;
        border-bottom: 1px solid rgba(0,0,0,0.06);;
      }
      div{
        margin: 24px;
        border: 1px solid #979797;
      }
    }
  </style>
  